// extracted by mini-css-extract-plugin
export default {"editorCont":"MergeModal_editorCont__b+S52","trashIcon":"MergeModal_trashIcon__q7+mo","confirmationText":"MergeModal_confirmationText__8-0Lj","yesNoBtn":"MergeModal_yesNoBtn__ngnkI"};